<template>
    <div class="register">
        <van-form @submit="onSubmit">
            <img :src="formset.banner" v-if="formset&&formset.banner"/>
             <div v-html="formset.des" v-if="formset.des"></div>
             <div v-if="formset.des" class="agree"><input type="checkbox" v-model="agree" v-if="formset.des"/><span>同意(agree)上方参会声明</span></div>
           <div  v-for="(item,index) in  fieldArr" :key="index">
                <van-cell-group :class="item.is_required?'required':''">
                    <van-field
                        v-if="item.type==0"
                        v-model="user[item.id]"
                        :label="item.label"
                        :placeholder="item.placeholder"
                        :rules="[{ required: item.is_required, message: item.label }]"
                    >
                    </van-field>
                    <van-field
                        v-if="item.type==4"
                        :label="item.label"
                        v-model="user[item.id]"
                        style="line-height:80px"
                        :rules="[{ required: item.is_required, message: item.label }]"
                    >
                        <template #input>
                            <van-uploader v-model="fileList" :max-count="1" 
                            :after-read="(file) => afterRead(file, item.id)"
                            :before-delete="(file) =>beforeDelete(file,item.id)"/>
                        </template>
                    </van-field>
                </van-cell-group>
            </div>
            <p class="state" >注意 :<span> * </span>为必填项</p>
            <div class="buttonGroup" ref='buttonGroup'>
               <van-button type="default" native-type="submit">确定</van-button>
              
            </div>
        </van-form>
    </div>
</template>  
<script>
    import {formUserAnswers,UploadCertificates}  from '../../../../config/interface.js'
    import  {Toast} from 'vant'
    export default {
        props:{
			fieldArr:Array,
            formset:Object
		},
        data(){
            return{
                user:{},
                fileList:[],
                agree:true
            }
		},
        methods:{
           onSubmit(){
                if(this.formset.des&&this.agree==false){
                    common.toast('请勾选同意(agree)按钮',2000);
                    return
                    
                }
                Toast.loading({
                    duration: 0,
                    forbidClick: true,
                    message: '',
                });
                const url=formUserAnswers;  
                let params={
                    module_id:this.$route.query.company_area_id,
                    answers:this.user,
                    type:'company_area'
                }
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    Toast.clear();
                    if(res.code==0){
                        common.toast('提交成功',1000);    
                        setTimeout(()=>{
                            this.$emit('func',this.infostatus);
                            this.$emit('changeAuth',true);
                        },1000)
                    }
                })
            },
            afterRead(file,id){
                const url=UploadCertificates;  
                let formData=new FormData();
                formData.append('certificates[0][file]',file.file);
                formData.append('certificates[0][type]',100)
                const method='POST';
                fetch(url,formData,method)
                .then((res)=>{
                    if(res.code==0){
                       this.user[id]=res.data[0].url;
                       console.log(this.user)
                    }
                })
            },
            beforeDelete(file,id){
                this.user[id]='';
                return  ()=>{}
            }
        }
    }
</script>
<style lang="scss">
   .register{
       width:320px;
	   padding:30px 20px 15px;
       box-sizing: border-box;
       img{
           width: 100%;
       }
       .agree{
            font-size: 14px;
            line-height: 40px;
            input{
                vertical-align: text-top;
            }
            margin: 10px 0;
       }
       .close{
           position:absolute;
           top:10px;
           right:10px;
           font-size:20px;
       }
       h2{
           font-size:20px;
           color:#901d22;
           text-align: center;
           margin-bottom:20px;
       }
       .van-radio-group{
           margin-bottom:15px;
           span{
               font-weight:bold
           }
       }
       .van-cell-group{
           display:flex;
           align-items: center;
		   font-size:15px;
           margin-bottom:15px;
           .van-cell{
                // border:1px solid #ddd;
               background:rgba(86,86,86,0.03);
               border-radius:10px;
               padding:10px 15px;
           }
           .van-cell:not(:last-child)::after{
               border:0px;
           }
       }
       .van-cell-group.address_info{
           margin-bottom:7px;
       }
       .van-cell-group:before{
            display:inline-block;
            vertical-align:middle;
            content:'*';
            margin-right:5px;
            color:#fff;
       }
       .van-cell-group.required:before{
               color:red;
        }
        .van-cell-group:after{
            border:0px;
        }
       button.sendCode{
            border-radius:0 10px 10px 0;
            font-size:12px;
            width:140px;
			border:0px;
			color:$color-main;
			background:#fff;
			// border-left:1px solid $color-main;
       }
       .buttonGroup{
           width:100%;
           display: flex;
           justify-content: space-around;
           margin-top:20px;
           button{
            width:134px;
            height:40px;
            color:#fff;
            background:rgba(154,154,154,1);
            border-radius:23px;
            font-size:17px;
           }
           button:last-child{
               background:#901D22;
           }
       }
       .success{
           padding:35px 15px;
           text-align: center;
           img{
               width:7rem;
           }
           h1{
               margin:0 0 10px;
               font-size:17px;
               letter-spacing: 1px;
               color:#090909;
           }
           p{
               color:#999;
               font-size:13px;
           }
       }
       .state{
           margin-left:10px;
           span{
               color:red;
           }
       }

   } 
</style>  


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/CollectInfo.vue